import modelExtend from 'dva-model-extend'
import {delay, pageModel} from './common'
import service from '../services/ticket'
import * as routerRedux from "react-router-redux"

export default modelExtend(pageModel, {

  namespace: 'ticketsubmit',
  state: {
    product: {}
  },
  subscriptions: {
    setupHistory({dispatch, history}) {
      history.listen((location) => {
        if (/\/ticket\/\d+$/.test(location.pathname)) {
          let paths = location.pathname.split('/')
          dispatch({
            type: 'init',
            payload: paths[2],
          })
        } else {
        }
      })
    },
  },
  effects: {
    * init({payload,}, {call, put, select}) {
      yield put({
        type: 'updateState',
        payload: {
          product: {},
          showSuccess: false,
          orderId: undefined,
          totalAmount: undefined,
          inventory: undefined,
        }
      })
      let app
      while (true) {
        app = yield select(_ => _['app'])
        if (app.ready) {
          break
        }
        yield call(delay, 100)
      }
      const {user} = app
      if (user == null) {
        yield put(routerRedux.replace('/login'))
        return
      }
      const product = yield call(service.getProduct, payload)
      if (product.freeTicket === 1) {
        const freeTicketCartTypes = yield call(service.getFreeTicketCardType)
        yield put({
          type: 'updateState',
          payload: {
            freeTicketCartTypes,
          }
        })
      }
      yield put({
        type: 'updateState',
        payload: {
          product,
        }
      })
    },
    * submit({payload,}, {call, put, select}) {
      const {product} = yield select(_ => _['ticketsubmit'])
      const {orderId, totalAmount} = yield call(service.submit, payload)
      if (product.freeTicket === 1) {
        // 免费票
        yield put(routerRedux.replace(`/ticket/order/${orderId}`))
      } else {
        yield put({
          type: 'updateState',
          payload: {
            showSuccess: true,
            orderId,
            totalAmount,
          }
        })
      }
    },
    * refreshInventory({payload: {
      productId, travelDate
    }}, {call, put, select}) {
      const {value, success} = yield call(service.getInventory, productId, travelDate.format('Y-MM-DD'))
      yield put({type: 'updateState', payload: {inventory: success ? value : null}})
    },
  },
  reducers: {
    showModal(state, {payload}) {
      return {
        ...state, ...payload,
        modalVisible: true,
      }
    },
    hideModal(state) {
      return {
        ...state,
        modalVisible: false,
      }
    },
  },
})
